import React from 'react';
import {makeStyles} from '@material-ui/core';
import PaperCustom from "../../common/PaperCustom";
import Carousel from 'react-material-ui-carousel'
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles(theme => ({
    containerExpertise: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        marginLeft: 'auto',
        marginRight: 'auto',
        height: 100,
        width: 300,
        [theme.breakpoints.only('xs')]: {
            width: 250,
        },
    },
    title: {
        textTransform: 'uppercase',
        margin: '10px 10px',
        fontSize: 22,
        [theme.breakpoints.down('sm')]: {
            fontSize: 18,
        },
    },
    chevron: {
        fontSize: 30,
        [theme.breakpoints.down('sm')]: {
            fontSize: 18,
        },
    },
}));

function Expertise() {
    const classes = useStyles();
    const ITEMS = [
        {
            value: <>EDR</>,
        },
        {
            value: <>FIREWALL</>,
        },
        {
            value: <>MFA</>,
        },
        {
            value: <>REVERSE PROXY</>,
        },
        {
            value: <>THREAT INTEL</>,
        },
        {
            value: <>AUDIT</>,
        },
        {
            value: <>SENSIBILISATION</>,
        },
        {
            value: <>CLOUD PUBLIC</>,
        }
    ];

    return (
        <PaperCustom title={"NOS EXPERTISES"} src={'/image/expertise/IconeMessage.png'} alt={"Logo"}>
            <Carousel navButtonsAlwaysVisible timeout={200} animation={"slide"} fullHeightHover={false}>
                {
                    ITEMS.map((item, i) => <div key={i} style={{display:'flex'}} >
                        <div className={classes.containerExpertise}>
                            <Typography className={classes.chevron}>&lsaquo;</Typography>
                            <Typography className={classes.title}>{item.value}</Typography>
                            <Typography className={classes.chevron}>&rsaquo;</Typography>
                        </div>
                    </div>)
                }
            </Carousel>
        </PaperCustom>
    )
}

Expertise.propTypes = {};

export default Expertise